import {
  ReviewsSection_ReviewSummary_ActionStatement_ActionStatementType as ActionStatementType,
  ReviewsSection_ReviewSummary_ActionStatement,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {
  COLORS,
  GenericIconName,
  Icon,
  IconName,
  Text,
} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';

export const ReviewsActionStatement: FC<{
  actionStatements: ReviewsSection_ReviewSummary_ActionStatement[];
}> = ({actionStatements}) => {
  return (
    <>
      {actionStatements.map((action, index) => (
        <ActionWrapper
          key={`action-statement-${index}`}
          data-testid={`actionStatement-${index}`}
        >
          {action.type !== 0 && (
            <Icon
              size={'S'}
              asset={GenericIconName[actionIcons[action.type]] as IconName}
              data-testid={`actionStatement-${
                action.type === 1 ? 'fit' : 'quality'
              }`}
            />
          )}
          <ActionTextContainer isIconRendered={action.type !== 0}>
            <Text
              weight="bold"
              data-testid={`actionStatementHeadline-${index}`}
            >
              {action.headline}
            </Text>
            <Text color="Grey2" data-testid={`actionStatementSubline-${index}`}>
              {action.subline}
            </Text>
          </ActionTextContainer>
        </ActionWrapper>
      ))}
    </>
  );
};

const actionIcons: {
  [k in ActionStatementType]: keyof typeof GenericIconName;
} = {
  // Value 0 is omitted and will not be rendered
  '0': GenericIconName.Close,
  '1': GenericIconName.Ruler,
  '2': GenericIconName.UspProofOfQuality,
};

const ActionWrapper = styled.div`
  border: 1px solid ${COLORS.Grey3};
  border-radius: 2px;
  display: flex;
  margin-bottom: 16px;
  padding: 12px 16px;
`;

const ActionTextContainer = styled.div<{isIconRendered: boolean}>`
  display: flex;
  flex-direction: column;
  margin-left: ${({isIconRendered}) => (isIconRendered ? '5px' : '30px')};
`;
